<app-error></app-error>
<div [@routeAnimations]="prepareRoute(outlet)" >
    <router-outlet #outlet="outlet" (activate)="onActivate($event)"></router-outlet>
</div>
<block-ui></block-ui>
